.field {
  position: absolute;
  z-index: 0;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  container-type: size;
  container-name: running-field;
  color: var(--status-warning);
}
.overdue {
  color: var(--status-serious);
}
.timing {
  width: min(12ch, 100%);
  max-width: 100%;
  min-width: 0;
  flex: 0 1 12ch;
  margin: 0;
  color: var(--ink-secondary);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.72em;
  font-variant-numeric: tabular-nums;
  text-align: end;
  white-space: nowrap;
  overflow: hidden;
}
.timingOverdue {
  color: var(--status-serious);
}
